const piiKeys = new Set(['name', 'email', 'phone', 'propertyAddress', 'urls']);

export const filterPii = (
  properties?: Record<string, unknown>
): undefined | Record<string, unknown> => {
  if (properties) {
    if (Array.isArray(properties)) {
      return properties.reduce((acc, item) => {
        if (typeof item === 'object') {
          return [...acc, filterPii(item as Record<string, unknown>)];
        }
        return [...acc, item];
      }, []);
    }
    return Object.keys(properties).reduce((acc, key) => {
      if (piiKeys.has(key) && properties[key]) {
        return { ...acc, [key]: 'PII' };
      }
      if (typeof properties[key] === 'object') {
        return { ...acc, [key]: filterPii(properties[key] as Record<string, unknown>) };
      }
      return { ...acc, [key]: properties[key] };
    }, {});
  }

  return undefined;
};
